import { createSvgIcon } from "@mui/material";

const DotIcon = createSvgIcon(
  <svg viewBox="0 0 10 10" fill="none">
    <circle cx="5" cy="5" r="4" fill="currentColor" stroke="white" strokeWidth="2" />
    <circle cx="5" cy="5" r="4" stroke="currentColor" strokeOpacity={0.1} strokeWidth="2" />
  </svg>,
  "DotIcon"
);

export default DotIcon;
